import React, { useRef } from 'react'
import { Popup, PopupProps, Ref } from 'semantic-ui-react'
import { useOnClickOutside } from '../../utils/useOnClickOutside'

interface PopupAwayClickProps extends PopupProps {
  setter(isOpen: boolean): void
}

const PopupAwayClick = React.forwardRef<PopupProps, PopupAwayClickProps>(
  ({ children, setter, ...props }) => {
    const ref = useRef(null)
    useOnClickOutside(ref, () => setter(false))
    return (
      <Ref innerRef={ref}>
        <Popup {...props} />
      </Ref>
    )
  }
)

export default PopupAwayClick
